export default __webpack_public_path__ + "static/logo-e-3-6289df8990f9cfd3b2cfa4cc74d9f109.png";